module.exports = __webpack_public_path__ + "img/mappa-urbanenvironments.c474c39a.svg";